import { App } from '@capacitor/app';
import { isNativeApp } from '../native';

/**
 * Meldet das Fortsetzen der nativen App (Capacitor `resume`). Im Browser gibt es nichts zu hören: Die Sichtbarkeit deckt
 * das dort ab. Gibt die Abmeldung zurück.
 */
export async function listenForResume(callback: () => void): Promise<() => void> {
  if (!isNativeApp()) return () => undefined;
  const handle = await App.addListener('resume', callback);
  return () => {
    void handle.remove();
  };
}
